import { Common } from '~/models/common';

export namespace Socials {
	export const collection = 'socials';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		title: string | null;
		link: string | null;
		icon:
			| 'social/telegram'
			| 'social/vk'
			| 'social/whatsapp'
			| 'social/whatsapp-inline'
			| 'social/max'
			| 'social/youtube'
			| null;
	};

	export const modelState: Model = {
		...Common.modelState,
		id: 0,
		title: null,
		link: null,
		icon: null,
	};
}
